<template>
  <v-card flat class="transparent" v-if="showDetails(comment)">
    <v-row no-gutters>
      <v-col>
        <v-card-subtitle class="text--primary font-weight-bold pb-0">{{ comment.author.name }}</v-card-subtitle>
        <v-card-subtitle class="py-0 mt-0">
          <span class="font-weight-bold">Re:</span> {{ comment.subject.name }}
        </v-card-subtitle>
      </v-col>
      <v-col align="right">
        <v-card-subtitle class="caption pb-0">{{ comment.created_at | moment('D/M/YY HH:mm:ss') }}</v-card-subtitle>
        <div class="pr-4">
          <v-icon small class="mr-1" v-if="comment.subject.type === 'Business'" color="light-grey">fad fa-user</v-icon>
          <v-icon small class="mr-1" v-if="comment.subject.type === 'Referral'" color="light-grey"
            >fad fa-people-carry</v-icon
          >
          <v-icon small class="mr-1" v-if="comment.subject.type === 'Enquiry'" color="light-grey">fad fa-coins</v-icon>
          <v-icon small v-if="comment.privacy === 'internal'" color="red">fad fa-lock-alt</v-icon>
          <v-icon small v-else color="accent">fad fa-lock-open-alt</v-icon>
        </div>
      </v-col>
    </v-row>
    <v-card-text class="text--primary">{{ comment.text }}</v-card-text>
    <v-divider v-if="!last"></v-divider>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'comment-card',
  props: {
    comment: Object,
    index: Number,
    total: Number
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['UserHasRole', 'AccountId', 'SelectedCustomer', 'Enquiries', 'OwnersList']),
    PlatformUser() {
      return this.UserHasRole('Platform');
    },
    first() {
      return this.total - this.index === this.total;
    },
    last() {
      return this.index === this.total - 1;
    },
    colour() {
      return this.comment.privacy === 'public' ? 'green darken-2' : 'red';
    }
  },
  methods: {
    isPlatformUser(id) {
      return _.find(this.OwnersList, { id });
    },
    showDetails(comment) {
      if (this.UserHasRole('Platform') || this.UserHasRole('Call Centre') || this.UserHasRole('Property Broker')) {
        return true;
      }
      return (
        comment.privacy === 'public' &&
        (comment.account_id === this.AccountId ||
          (this.UserHasRole('Partner') &&
            comment.subject.type === 'Referral' &&
            this.comment.visibility.account_id === this.AccountId) ||
          (this.UserHasRole('Provider') && comment.subject.type === 'Business') ||
          (this.UserHasRole('Provider') &&
            comment.subject.type === 'Enquiry' &&
            this.AccountId === this.comment.visibility.account_id))
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
